import React from 'react';
import Text11 from '@sdk/components/ui/typography/Text11';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Button from '@sdk/components/ui/buttons/Button';

import { ButtonContainer } from '@web/components/survey/ButtonContainer';
import SurveyStep from '@web/components/survey/SurveyStep';
import { STEPS_CONFIG, NpsSteps, ACTIONABLE_STEPS_COUNT } from '@web/components/npsScore/constants';

import { ScoreRow, Score, ScoreText } from './npsRateStep.styles';

type Props = {
  onSetScore: (score: number) => void;
  score: number | null;
  submitStep: () => void;
};

const NpsRateStep: React.FC<Props> = ({ onSetScore, score, submitStep }) => {
  const currentStep = STEPS_CONFIG[NpsSteps.rate];

  return (
    <SurveyStep
      number={currentStep.number}
      count={ACTIONABLE_STEPS_COUNT}
      subtitle={currentStep.subtitle}>
      <ScoreRow>
        {new Array(11).fill(true).map((_, i) => (
          <Score key={`${i}`} isSet={score === i} onClick={(): void => onSetScore(i)}>
            <ScoreText
              themeColor={score === i ? ThemeColorType.primary : ThemeColorType.primaryText}>
              {i}
            </ScoreText>
          </Score>
        ))}
      </ScoreRow>
      <ScoreRow>
        <Text11 italic themeColor={ThemeColorType.iconGray}>
          {gettext('Not at all likely')}
        </Text11>
        <Text11 italic themeColor={ThemeColorType.iconGray}>
          {gettext('Extremely likely')}
        </Text11>
      </ScoreRow>

      <ButtonContainer>
        <Button disabled={score === null} buttonType={ButtonType.primary} onClick={submitStep}>
          {gettext('Next')}
        </Button>
      </ButtonContainer>
    </SurveyStep>
  );
};

export default NpsRateStep;
